var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 6.35 6.35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80.913 -99.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.088 99.483c-1.536 0-2.7935 1.2575-2.7935 2.7935 0 1.5369 1.2575 2.7935 2.7935 2.7935 1.536 0 2.7935-1.2566 2.7935-2.7935 0-1.536-1.2575-2.7935-2.7935-2.7935zm0 0.83834c0.46027 0 0.83835 0.37715 0.83835 0.83833 0 0.46025-0.37808 0.83741-0.83835 0.83741-0.46025 0-0.83832-0.37716-0.83832-0.83741 0-0.46118 0.37807-0.83833 0.83832-0.83833zm0.0101 4.0638c-1.0557 0-1.6602-0.70499-1.6429-1.4219 0.01379-0.55888 1.084-0.62646 1.6429-0.62646 0.55888 0 1.6958 0.0676 1.7095 0.62646 0.01543 0.63286-0.65478 1.4219-1.7095 1.4219z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.23378
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.e5e2b12a7ba012657c1d955a04873927.svg";
export { ForwardRef as ReactComponent };